import React, {Component} from "react";
import {Layout, message} from "antd";
import Header from "../../components/header";
import LeftNav from "../../components/leftNav";

import {reqSkillDetail} from "../../api";
import './skillDetail.less';

const { Content } = Layout;

/**
 * 技能训练详情的路由组件
 */
export default class SkillDetail extends Component {

    state = {
        detailId:0,
        title:'',
        imgs:[],
        questionType:'',
        questions : [],
        options:[''],
        diagnosis:'',
        meaning:'',
        feature : '',
        pro_display:true,
        que_display:false,
        btn_display:false,
        analysis:'',
        idArr:[],
        lastDetail:false,
        firstDetail:false
    };

    getSkillDetail = async (detailId) => {
        const result = await reqSkillDetail(detailId);
        if(result.code ==='000000') {
            const detailId = result.data.detailId;
            const title = result.data.title;
            const imgs = result.data.imgs;
            const questionType = result.data.questionType;
            const questions = result.data.questions;
            const options = result.data.options;
            const diagnosis = result.data.diagnosis;
            const meaning = result.data.meaning;
            const feature = result.data.feature;
            this.setState({
                detailId:detailId,
                title:title,
                imgs:imgs,
                questionType:questionType,
                questions : questions,
                options:options,
                diagnosis:diagnosis,
                meaning:meaning,
                feature : feature
            });
        }else {
            message.error(result.msg);
        }
    };

    proCheck =()=> {
        this.setState({
            pro_display:false,
            que_display:true
        })
    };

    closeContent = () => {
        this.setState({
            pro_display:true,
            que_display:false
        })
    };

    answerSubmit = () => {
        this.setState({
            btn_display:true
        });
        let check = document.getElementsByName("option");
        let choice = document.getElementsByName("choice");
        let correct = this.state.questions[0].correctAnswer;
        let answer = "";
        let options = this.state.options;
        for (let i = 0; i < check.length; i++) {
            if(check[i].checked){
                answer += (check[i].value+"|");
            }
        }
        answer = answer.substring(0,answer.length-1);
        if(correct===answer) {
            this.setState({
                analysis:'选择正确'
            });
        }else {
            let reg = new RegExp(/[|]/,"g");
            let co = correct.replace(reg,"");
            this.setState({
                analysis:'选择错误，正确答案是'+co
            });
        }
        for (let i = 0; i < options.length; i++) {
            if(correct.indexOf(options[i].optionKey)>-1){
                choice[i].setAttribute("class","success");
                if(answer.indexOf(options[i].optionKey)>-1){
                    choice[i].click();
                }
            }else if(answer.indexOf(options[i].optionKey)>-1){
                choice[i].click();
                choice[i].setAttribute("class","error");
            }
            choice[i].disabled = true;
            check[i].disabled = true;
        }
    };

    prevSkill = async () => {
        let detailId = sessionStorage.getItem("detailId");
        const idArr = this.state.idArr;
        let index = 0;
        for (let i = 0; i < idArr.length; i++) {
            if(detailId===idArr[i]){
                index = i;
                break;
            }
        }
        if(index>0){
            this.getSkillDetail(idArr[index-1]);
            sessionStorage.setItem("detailId",idArr[index-1]);
            this.setState({
                lastDetail:false,
            });
            if(index === 1){
                this.setState({
                    firstDetail:true
                })
            }
        }else {
            message.info("这是第一条");
        }
        this.clearChoice();
        this.closeContent();
        window.scroll(0,0);
    };

    nextSkill = async () => {
        this.setState({
            firstDetail:false
        });
        let detailId = sessionStorage.getItem("detailId");
        const idArr = this.state.idArr;
        let index = 0;
        for (let i = 0; i < idArr.length; i++) {
            if(detailId===idArr[i]){
                index = i;
                break;
            }
        }
        if(index<idArr.length-1){
            this.getSkillDetail(idArr[index+1]);
            sessionStorage.setItem("detailId",idArr[index+1]);
            if(index === idArr.length-2){
                this.setState({
                    lastDetail:true
                })
            }
        }
        this.clearChoice();
        this.closeContent();
        window.scroll(0,0);
    };

    clearChoice (){
        let arr = document.getElementsByName("choice");
        let check = document.getElementsByName("option");
        for(let i=0;i<arr.length;i++){
            arr[i].setAttribute("class","");
            arr[i].disabled = false;
            check[i].disabled = false;
        }
        this.setState({
            analysis:"",
            btn_display:false
        });
    };

    toSkill (e) {
        sessionStorage.setItem("cid",e.key);
        this.props.history.push("/skill");
    };

    componentDidMount = async() =>{
        let detailId = sessionStorage.getItem("detailId");
        this.getSkillDetail(detailId);
        let idArr = sessionStorage.getItem("idArr").split(",");
        if(idArr[0] === detailId){
            this.setState({
                firstDetail:true,
            });
        }
        if(idArr[idArr.length-1] === detailId){
            this.setState({
                lastDetail :true,
            });
        }
        this.setState({
            idArr:idArr,
        });
        document.getElementsByClassName("logo_t")[0].setAttribute("hidden",true);
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render() {

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftNav>LeftNav</LeftNav>
                    <Content>
                        <div className="detail">
                            <div className="detail_content">
                                <div className="details_left">
                                    <div className="details_img">
                                        <img style={{width:"100%"}} src={this.state.imgs?global.constant.uploadImage+this.state.imgs[0]:require("../../assets/images/head.jpg")} className="img-responsive"/>
                                    </div>
                                    <div className="detail_change">
                                        <a className={this.state.firstDetail?'no_next':"prev"} onClick={this.prevSkill}>上一题</a>
                                        <a className={this.state.lastDetail?'no_next':"next"} onClick={this.nextSkill}>下一题</a>
                                    </div>
                                </div>
                                <div className="details_right">
                                    <div className="question" hidden={this.state.que_display}>
                                        <div className="title">{this.state.title}：</div>
                                        <form>
                                            <div className="question_all">
                                                {
                                                    this.state.options && this.state.options.map((option, index) => {
                                                        return (
                                                            <div className="que_checkbox" key={index}>
                                                                <label>
                                                                <input type="checkbox" name="option" value={option.optionKey}/>
                                                                <div name="choice">{option.optionKey} {option.optionValue}</div>
                                                                </label>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                            <div className="tips">{this.state.analysis}</div>
                                            <button className="btn_pro" type="button" onClick={this.proCheck}>专家诊断</button>
                                            <button type="button" className="btn_submit" hidden={this.state.btn_display} onClick={this.answerSubmit}>提交</button>
                                        </form>
                                    </div>
                                    <div className="pro_content" hidden={this.state.pro_display}>
                                        <div className="pro_close" onClick={this.closeContent}/>
                                        <div className="pro_info">
                                            <div className="info_title">{this.state.diagnosis}</div>
                                            <div className="info_item">
                                                <div className="item_title">特征</div>
                                                <div className="item_con">{this.state.feature}</div>
                                            </div>
                                            <div className="info_item">
                                                <div className="item_title red">临床意义</div>
                                                <div className="item_con">{this.state.meaning}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}